import { FC, useEffect, useState } from 'react'
import './Onboarding.scss'
import React from 'react'

type OnboardingQuestion = {
  questionId: string;
  title: string;
  options: string[];
  subTitle: string;
  answer?: string | string[] | null;
}

type MultipleSelectProps = {
  data: OnboardingQuestion;
  setIsDisable: (value: boolean) => void;
  onSubmit: (answer: string[] | [] | Record<string, string[]>) => void;
}

const MultipleSelect: FC<MultipleSelectProps> = ({ data, setIsDisable, onSubmit }) => {
  const [selectedOption, setSelectedOption] = useState<string[]>(data?.answer as string[] ?? []);

  const handleChange = (option: string) => {
    let updatedOptions: string[];

    if (selectedOption.includes(option)) {
      // Remove if already selected
      updatedOptions = selectedOption.filter((item) => item !== option);
    } else {
      // Add if not selected
      updatedOptions = [...selectedOption, option];
    }

    setSelectedOption(updatedOptions);
    setIsDisable(updatedOptions.length === 0);
    onSubmit({ [data.questionId]: updatedOptions });
  };

  useEffect(() => {
    if (selectedOption.length > 0) {
      setIsDisable(selectedOption.length === 0);
    } else {
      setIsDisable(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.answer]);

  const isMultipleColumn = data.options.length > 5;

  return (
    <>
      <div className='fw-boldest fs-3'>{data.title}</div>
      <div className='onboarding-description'>{data.subTitle}</div>
      <div className={`gap-4 mt-10 ${isMultipleColumn ? 'd-flex flex-wrap' : ''}`}>
        {data.options.map((opt) => (
          <div
            key={opt}
            className='form-check form-check-custom form-check-solid mb-5'
            style={isMultipleColumn ? { width: 'calc(50% - 1rem)' } : {}}
            onChange={() => handleChange(opt)}
          >
            <input
              id={opt}
              className='form-check-input widget-9-check radio-input'
              type='checkbox'
              value={opt}
              checked={selectedOption.includes(opt)}
              onChange={() => handleChange(opt)}
            />
            <label className='form-check-label option-label' htmlFor={opt}>
              {opt}
            </label>
          </div>
        ))}
      </div>
    </>
  );
};

export default React.memo(MultipleSelect)
